import { SystemMessageModel } from 'src/app/models/system-messages/system-message.model';
import { Subject } from 'rxjs';
import * as i0 from "@angular/core";
export class SystemMessageService {
    constructor() {
        this.messageSubject = new Subject();
    }
    showMessage(message, status) {
        let messageModel = new SystemMessageModel({
            message: message,
            status: status
        });
        this.messageSubject.next(messageModel);
    }
    get messages$() {
        return this.messageSubject.asObservable();
    }
}
SystemMessageService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function SystemMessageService_Factory() { return new SystemMessageService(); }, token: SystemMessageService, providedIn: "root" });
